import React from "react";
import Social from "../Social";



const About = () => {
  return (
    <>
      <section id="quienes-somos" className="section theme-light dark-bg">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-duration="1200"
            >
              {/* Preload about image for LCP */}
              <link rel="preload" href="/img/about/about-me.png" as="image" />
              <div className="about-me">
                <div className="img">
                  <div className="img-in"
                    style={{ width: 400, height: 400, backgroundColor: "#f5f5f5" }}>
                    <picture>
                      <source srcSet="/img/about/about-me.png" type="image/png" />
                      <img
                        src="/img/about/about-me.png"
                        alt="about"
                        width="360"
                        height="360"
                        loading="eager"
                        priority="true" />
                    </picture>
                  </div>

                  <Social />

                  {/* End social icon */}
                </div>
                {/* End img */}
                <div className="info">
                  <h2 className="h3">Democratizando la Tecnología</h2>
                </div>
                {/* End info */}
              </div>
              {/* End about-me */}
            </div>
            {/* End col */}

            <div
              className="col-lg-7 ml-auto"
              data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-delay="200"
            >
              <div className="about-info">
                <div className="title">
                  <h2 className="h3">Quiénes Somos</h2>
                </div>

                <div className="about-text">
                  <p>
                    Fundados en 2020, eliminamos las barreras técnicas para los negocios. Nuestra misión es que toda empresa, sin importar su tamaño, acceda a herramientas de nivel corporativo para ser rentable en la web. Operamos desde Jalisco, México, con un enfoque en eficiencia operativa y seguridad de datos.
                  </p>

                </div>
              </div>
            </div>
            {/* End col */}
          </div>
        </div>
      </section>
      {/* End About Section */}
    </>
  );
};

export default About;
